module.exports = __webpack_public_path__ + "img/DIO2000_R.b35e94f0.png";